import { render, staticRenderFns } from "./pageHeader.vue?vue&type=template&id=39c2290a&scoped=true"
import script from "./pageHeader.vue?vue&type=script&lang=js"
export * from "./pageHeader.vue?vue&type=script&lang=js"
import style0 from "./pageHeader.vue?vue&type=style&index=0&id=39c2290a&prod&lang=scss"
import style1 from "./pageHeader.vue?vue&type=style&index=1&id=39c2290a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c2290a",
  null
  
)

export default component.exports